import { render, staticRenderFns } from "./CytologyCaseTests.vue?vue&type=template&id=0ba13b44&scoped=true&"
import script from "./CytologyCaseTests.vue?vue&type=script&lang=js&"
export * from "./CytologyCaseTests.vue?vue&type=script&lang=js&"
import style0 from "./CytologyCaseTests.vue?vue&type=style&index=0&id=0ba13b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba13b44",
  null
  
)

export default component.exports